var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"id":"close-game"},on:{"click":function($event){return _vm.closeGame()},"touchend":function($event){return _vm.closeGame()}}},[_vm._v(_vm._s(_vm.$t('Back')))]),_vm._v(" "),_c('InfoScreen')],1)}
var staticRenderFns = []

export { render, staticRenderFns }